import { useFormik } from 'formik'
import { Fragment, useEffect, useState } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { makeStyles } from '@mui/styles';
import { KTSVG } from '../../../_metronic/helpers'
import { ModalStyled } from '../../components/Modals.styled';
import { modalStyles } from '../../components/ModalStyles';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { InputStyled } from '../../components/Inputs.styled';
import axios from 'axios';
import { Button, Backdrop, Fade, InputAdornment, CircularProgress } from '@mui/material';
import { ClearIconStyled, IconButtonClearStyled, IconButtonStyled } from '../../components/LTLandVolumeTLPages/ZipcodesWithCountry.styled';
import * as Yup from 'yup';
import ShippingLocationsModal from '../../components/ShippingLocationsModal/ShippingLocationsModal';


import { UserModel } from '../../modules/auth/models/UserModel';
import { useSelector, shallowEqual } from 'react-redux';
import { RootState } from '../../../setup/redux/RootReducer';
import { getWeekOfMonthWithOptions } from 'date-fns/fp';


const GET_SL = '/api/v1/database/shippinglocation'
const QUICKENTRY = '/applet/v1/email/quickentry'
const SAVE_SHIPPING_LOCATION = '/api/v1/database/shippinglocation'

export const QuickWizard = () => {
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const fontSize = useSelector<RootState>(({ pages }) => pages.fontSize) as number
  const initialLocationValue = {
    name: '',
    city: '',
    state: '',
    zipcode: ''
  }
  const initialFormikValues = {
    pickupLocation: initialLocationValue,
    deliveryLocation: initialLocationValue,
    requestType: '',
    name: '',
    email: '',
    shingle: {
      "quantity": null,
      "totalWeight": null
    },
    siding: {
      "quantity": null,
      "totalWeight": null
    },
    looseCarton: {
      "totalWeight": null
    },
    other: {
      "description": "",
      "quantity": null,
      "totalWeight": null
    },
    serviceLevel: '',
    orderNumbers: [],
    shippingContactEmail: "",
    documents: [],
    notes: ""
  }
  const [pickupLocation, setPickupLocation] = useState(initialLocationValue)
  const [pickupLocationOptions, setPickupLocationOptions] = useState([])
  const [deliveryLocation, setDeliveryLocation] = useState(initialLocationValue)
  const [deliveryLocationOptions, setDeliveryLocationOptions] = useState([])
  const [isSending, setIsSending] = useState(false)
  const [open, setOpen] = useState(false)
  const modalclasses = modalStyles({});
  const [fileName, setFileName] = useState('')
  const [openModalLocation, setOpenModalLocation] = useState(false)
  const [entityType, setEntityType] = useState('')
  const defaultFilterOptions = createFilterOptions()

  const useStyles = makeStyles({
    textField: {
      backgroundColor: 'white',
      borderRadius: '0.475rem',
      "& .Mui-error": {
        border: '1px solid #F1416C !important'
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        border: 'none'
      },
      "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        border: 'none'
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
        color: "#5E6278"
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: 'none',
      },
      "& .MuiOutlinedInput-root": {
        color: "#5E6278"
      },
      "& .MuiInputBase-input": {
        paddingLeft: '4px !important',
      },
      "& .Mui-disabled": {
        backgroundColor: '#EFF2F5',
      }
    },
    height: {
      height: fontSize === 9 ? '30px' : fontSize === 11 ? '40px' : 'var(--input-height)',
    },
  })

  const classes = useStyles()

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChangeRadios = (event: React.ChangeEvent<HTMLInputElement>, field) => {
    formik.setFieldValue(field, (event.target as HTMLInputElement).value)
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const maxSize = 20000000

    if (file && file.size <= maxSize) {      
      setFileName(file.name)
      formik.setFieldValue('documents', [file])
      // formik.handleChange(event)
    } else {
      setFileName('');
      alert("file size is greather tan 2 megabytes")
    }
  };

  const setLocationExternal = (value) => {
    switch (entityType) {
      case 'pickupLocation':
        setPickupLocation(value)
        setPickupLocationOptions([value])
        formik.setFieldValue('pickupLocation', value)
        break
      case 'deliveryLocation':
        setDeliveryLocation(value)
        setDeliveryLocationOptions([value])
        formik.setFieldValue('deliveryLocation', value)
        break
      default:
        setPickupLocation(value)
        setPickupLocationOptions([value])
        formik.setFieldValue('pickupLocation', value)
    }
  }


  const validationWizard = Yup.object().shape({
    requestType: Yup.string().trim().required('Please select a type'),
    serviceLevel: Yup.string().trim().required('Please select a type'),
    name: Yup.string().trim().required('Please select a type'),
    email: Yup.string().email().required('Required'),
    // pickupLocation: Yup.object({
    //   name: Yup.string().required('Required')
    // }),
    // deliveryLocation: Yup.object({
    //   name: Yup.string().required('Required')
    // }),
    orderNumbers: Yup.array().min(1, "at least 1").required("required"),
    shippingContactEmail: Yup.string().email().required('Required')
  })

  const resetForm = () => {
    formik.resetForm()
  }

  const getShippingLocations = (value) => {
    axios.get(GET_SL, {
      // cancelToken: cancelToken.token,
      params: {
        search: value,
        active: true
      }
    }).then(result => {
      let results = result.data.data.results
      if (results.length == 0) {
        results = [{ id: null }]
      }
      switch (entityType) {
        case 'pickupLocation':
          setPickupLocationOptions(results)
          break
        case 'deliveryLocation':
          setDeliveryLocationOptions(results)
          break
        default:
          setDeliveryLocationOptions(results)
      }
      // }
      // else {
      //   console.log("no options")
      // }
      // console.log(pickupShippingLocations)
    })
  }

  /*
  const addNewLocation = (props) => {
    return (
      <Button
        sx={{ paddingLeft: '20px' }}
        onClick={(e) => {          
          setAndAddNewLocation(props)
          e.stopPropagation();
        }}
      >
        Add New Location
      </Button>
    )
  }

  const setAndAddNewLocation = (props) => {

    let addedOption = {
      code: "",
      name: props.value,
      address: "",
      address1: "",
      phone: null,
      fax: null,
      email: "",
      city: "",
      state: "",
      country: "US",
      zipcode: "",
      active: true,
      contact: "",
      contactPhone: null,
      opentime: "",
      closetime: "",
      remarks: "",
      alertUser: false
    }

    axios.post(SAVE_SHIPPING_LOCATION,
      addedOption,
    ).then(result => {
      switch (props.field) {
        case 'pickupLocation':
          setPickupLocation(result.data.data.results)
          setPickupLocationOptions([result.data.data.results])
          formik.setFieldValue('pickupLocation', result.data.data.results)
          break
        case 'deliveryLocation':
          setDeliveryLocation(result.data.data.results)
          setDeliveryLocationOptions([result.data.data.results])
          formik.setFieldValue('deliveryLocation', result.data.data.results)
          break
        default:
          setPickupLocation(result.data.data.results)
          setPickupLocationOptions([result.data.data.results])
          formik.setFieldValue('pickupLocation', result.data.data.results)
      }
    }).catch(error => {
      console.log(error)
      // setIsSending(false)
    })
  }
  */

  const formik = useFormik({
    initialValues: initialFormikValues,
    validationSchema: validationWizard,
    // validationSchema: () => validationSchema({dispatchShipment: false, mode: mode, requireDimensions: user.requireDimensions}),
    validateOnChange: true,
    enableReinitialize: true,
    onSubmit: (values, formikBag) => {
      setIsSending(true)

      const formData = new FormData()
      formData.append('name', values.name)
      formData.append('email', values.email)
      formData.append('requestType', values.requestType)
      formData.append('shingle[quantity]', values.shingle.quantity || 0)
      formData.append('shingle[totalWeight]', values.shingle.totalWeight || 0)
      formData.append('siding[quantity]', values.siding.quantity || 0)
      formData.append('siding[totalWeight]', values.siding.totalWeight || 0)
      formData.append('looseCarton[totalWeight]', values.looseCarton.totalWeight || 0)
      formData.append('other[description]', values.other.description)
      formData.append('other[quantity]', values.other.quantity || 0)
      formData.append('other[totalWeight]', values.other.totalWeight || 0)
      formData.append('serviceLevel', values.serviceLevel)
      formData.append('notes', values.notes)
      formData.append('shippingContactEmail', values.shippingContactEmail)
      // formData.append('pickupLocation', values.pickupLocation)
      // formData.append('deliveryLocation', values.deliveryLocation)

      formData.append('pickupLocation[active]', (values.pickupLocation.active || ''))
      formData.append('pickupLocation[address]', (values.pickupLocation.address || ''))
      formData.append('pickupLocation[address1]', (values.pickupLocation.address1 || ''))
      formData.append('pickupLocation[alertUser]', (values.pickupLocation.alertUser || ''))
      formData.append('pickupLocation[city]', (values.pickupLocation.city || ''))
      formData.append('pickupLocation[closetime]', (values.pickupLocation.closetime || ''))
      formData.append('pickupLocation[code]', (values.pickupLocation.code || ''))
      formData.append('pickupLocation[contact]', (values.pickupLocation.contact || ''))
      formData.append('pickupLocation[contactPhone]', (values.pickupLocation.contactPhone || ''))
      formData.append('pickupLocation[country]', (values.pickupLocation.country || ''))
      formData.append('pickupLocation[createdByUser]', (values.pickupLocation.createdByUser || ''))
      formData.append('pickupLocation[dateSaved]', (values.pickupLocation.dateSaved || ''))
      formData.append('pickupLocation[email]', (values.pickupLocation.email || ''))
      formData.append('pickupLocation[fax]', (values.pickupLocation.fax || ''))
      formData.append('pickupLocation[id]', (values.pickupLocation.id || 0))
      formData.append('pickupLocation[lastUpdate]', (values.pickupLocation.lastUpdate || ''))
      formData.append('pickupLocation[name]', (values.pickupLocation.name || ''))
      formData.append('pickupLocation[opentime]', (values.pickupLocation.opentime || ''))
      formData.append('pickupLocation[phone]', (values.pickupLocation.phone || ''))
      formData.append('pickupLocation[remarks]', (values.pickupLocation.remarks || ''))
      formData.append('pickupLocation[state]', (values.pickupLocation.state || ''))
      formData.append('pickupLocation[zipcode]', (values.pickupLocation.zipcode || ''))

      formData.append('deliveryLocation[active]', (values.deliveryLocation.active || ''))
      formData.append('deliveryLocation[address]', (values.deliveryLocation.address || ''))
      formData.append('deliveryLocation[address1]', (values.deliveryLocation.address1 || ''))
      formData.append('deliveryLocation[alertUser]', (values.deliveryLocation.alertUser || ''))
      formData.append('deliveryLocation[city]', (values.deliveryLocation.city || ''))
      formData.append('deliveryLocation[closetime]', (values.deliveryLocation.closetime || ''))
      formData.append('deliveryLocation[code]', (values.deliveryLocation.code || ''))
      formData.append('deliveryLocation[contact]', (values.deliveryLocation.contact || ''))
      formData.append('deliveryLocation[contactPhone]', (values.deliveryLocation.contactPhone || ''))
      formData.append('deliveryLocation[country]', (values.deliveryLocation.country || ''))
      formData.append('deliveryLocation[createdByUser]', (values.deliveryLocation.createdByUser || ''))
      formData.append('deliveryLocation[dateSaved]', (values.deliveryLocation.dateSaved || ''))
      formData.append('deliveryLocation[email]', (values.deliveryLocation.email || ''))
      formData.append('deliveryLocation[fax]', (values.deliveryLocation.fax || ''))
      formData.append('deliveryLocation[id]', (values.deliveryLocation.id || 0))
      formData.append('deliveryLocation[lastUpdate]', (values.deliveryLocation.lastUpdate || ''))
      formData.append('deliveryLocation[name]', (values.deliveryLocation.name || ''))
      formData.append('deliveryLocation[opentime]', (values.deliveryLocation.opentime || ''))
      formData.append('deliveryLocation[phone]', (values.deliveryLocation.phone || ''))
      formData.append('deliveryLocation[remarks]', (values.deliveryLocation.remarks || ''))
      formData.append('deliveryLocation[state]', (values.deliveryLocation.state || ''))
      formData.append('deliveryLocation[zipcode]', (values.deliveryLocation.zipcode || ''))

      for (let orderNumber of values.orderNumbers) {
        formData.append('orderNumbers[]', orderNumber)
      }

      for (let file of values.documents) {
        formData.append('documents[]', file)
      }

      axios.post(QUICKENTRY,
        formData,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data',
          }
        },
      ).then(result => {
        setIsSending(false)
        setOpen(true)

        setDeliveryLocation(initialLocationValue)
        setPickupLocation(initialLocationValue)
        setFileName('')

        formik.setValues(initialFormikValues, true)
        resetForm()

      }).catch(error => {
        console.log(error)
        setIsSending(false)
      })
    }
  })

  // useEffect(() => {
  //   if (Object.keys(formik.errors).length) {
  //     // window.scrollTo(0, 0)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [formik.errors])

  return (
    <>
      <PageTitle>Quick Wizard</PageTitle>
      <form onSubmit={formik.handleSubmit}>

        <div className="container" style={{ padding: '0 10px', marginBottom: '10px' }}>
          <div className="row">
            <div className="col-12 d-flex mb-5 align-items-center">
              <label className='me-2' style={{ width: '50px' }}>
                Name:
              </label>
              <InputStyled
                type="text"
                className={`form-control`}
                autoComplete='off'
                name='name'
                value={formik.values.name}
                onChange={formik.handleChange}
                error={formik.errors?.name && formik.touched?.name}
                helperText={formik.errors?.name && formik.touched?.name ? 'Please enter a name' : ''}
              />

            </div>
            <div className="col-12 d-flex mb-5 align-items-center">
              <label className='me-2' style={{ width: '50px' }}>
                Email:
              </label>
              <InputStyled
                type="email"
                className={`form-control`}
                autoComplete='off'
                name='email'
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.errors?.email && formik.touched?.email}
                helperText={formik.errors?.email && formik.touched?.email ? 'Please enter an email' : ''}
              />
            </div>
          </div>
          <div className="row">
            <div className='col-12'>
              <h2>I want to:</h2>
            </div>
          </div>

          <div className="row">
            <FormControl className='d-flex'>
              <RadioGroup
                sx={{ flexDirection: 'row' }}
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="requestType"
                value={formik.values.requestType}
                onChange={(e) => handleChangeRadios(e, 'requestType')}
              >
                <FormControlLabel value="booking" control={<Radio />} label="Book a shipment" />
                <FormControlLabel value="quote" control={<Radio />} label="Get a quote" />
              </RadioGroup>
            </FormControl>
            {formik.errors.requestType && formik.touched.requestType ? <small className="text-danger ms-2 mt-1">{formik.errors.requestType}</small> : null}
          </div>
        </div>

        <div className='container' style={{padding: '0', color: '#f1416c', marginBottom: '20px'}}>
            Select pick and delivery addresses, or attached a PDF of ABC PO:
        </div>

        <div className="container" style={{ padding: '0' }}>
          <div className="row">
            <div className="col-12 d-flex mb-5" style={{ alignItems: 'center' }}>
              <label className='me-2' style={{ width: '40px' }}>
                Pick:
              </label>
              <Autocomplete
                id="country-select-demo"
                autoSelect={true}
                freeSolo={false}
                autoComplete={true}
                autoHighlight={true}
                className="dropdownContainer w-100"
                forcePopupIcon={false}
                // sx={{ width: 300 }}                
                // freeSolo={false}
                // defaultValue={pickupLocation ? pickupLocation : null }
                sx={{
                  backgroundColor: '#FFFFFF',
                  height: 'var(--input-height)',
                  minWidth: '74px',
                  borderRadius: '0.475rem',
                  width: '100%',
                  '& fieldset': {
                    border: 'none'
                  },
                  '& .MuiInputBase-root': {
                    height: 'var(--input-height)',
                    padding: '0 0 0 9px !important',
                    backgroundColor: '#ffffff'
                  }
                }}
                options={pickupLocationOptions}
                filterOptions={(options) => options}
                value={pickupLocation ? pickupLocation : initialLocationValue}
                getOptionLabel={(option) => `${option?.code ? `[${option.code}] ` : ''}${option?.name}${option?.city ? '. ' : ''}${option?.city}${option.city ? ', ' : ''}${option?.state}${option?.zipcode}`}
                // filterOptions={(options, state) => {
                //   const results = defaultFilterOptions(options, state)
                //   if (results.length === 0 && state.inputValue.length > 3) {
                //     return [{ id: null, value: state.inputValue, field: 'pickupLocation' }]
                //   }
                //   return results
                // }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  if (option?.id) {
                    return (
                      <Box
                        key={optionProps["data-option-index"]}
                        component="li"
                        sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                        {...optionProps}
                      >
                        <KTSVG path='/media/icons/bootstrap/building.svg' className='svg-icon svg-icon-5 me-2 text-danger' />
                        {`${option?.code ? `[${option.code}] ` : ''}${option?.name} ${option?.city ? '.' : ''} ${option?.city} ${option.city ? ',' : ''} ${option?.state} ${option?.zipcode}`}
                      </Box>
                    )
                  }
                  // else {
                  //   return (
                  //     addNewLocation(option)
                  //   )
                  // }
                }}
                onChange={(e: object, value: any | null) => {
                  if (value) {
                    setPickupLocation(value)
                    formik.setFieldValue("pickupLocation", value)
                  }
                }}
                onFocus={() => setEntityType('pickupLocation')}
                onInputChange={(e, value) => {
                  if (e?.type === "change") {
                    if (value?.length >= 3) {
                      // if (typeof cancelToken != typeof undefined) {
                      //   cancelToken.cancel('Operation canceled due to new request.')
                      // }

                      // cancelToken = axios.CancelToken.source()
                      // console.log("input change")         
                      // setLoading(true)
                      getShippingLocations(value)
                    }
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name='pickupLocation'
                    // label="Choose a country"
                    // error={formik.errors?.pickupLocation?.name && formik.touched?.pickupLocation}
                    // helperText={"fieldState.error?.message"}
                    className={classes.textField}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <InputAdornment position="end" className='d-flex align-items-center'>
                          {
                            pickupLocation?.id ?
                              <IconButtonClearStyled
                                onClick={() => {
                                  setPickupLocation(initialLocationValue)
                                  formik.setFieldValue('pickupLocation', initialLocationValue)
                                }}
                                style={{ padding: '2px !important' }}
                              >
                                <ClearIconStyled style={{ color: 'rgb(161, 165, 183) !important' }} />
                              </IconButtonClearStyled>
                              : null
                          }
                          <IconButtonStyled disabled={false}
                            onClick={() => {
                              setEntityType('pickupLocation')
                              setOpenModalLocation(true)
                            }
                            }
                          >
                            {false ? <div className='d-flex align-items-center'><CircularProgress color="inherit" size={15} /></div> : <KTSVG path='/media/icons/bootstrap/search.svg' className='svg-icon svg-icon-6' style={{ color: '#a1a5b7' }} />}
                          </IconButtonStyled>
                        </InputAdornment>
                      ),
                      className: classes.height,
                      style: { fontSize: 14, fontFamily: 'Poppins', fontWeight: 500, paddingRight: 9, color: "#5E6278 !important" },
                      inputProps: {
                        ...params.inputProps,
                        maxLength: 120
                      }
                    }}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password',
                    }}
                  />
                )}
              />

            </div>
            <div className="col-12 d-flex mb-5" style={{ alignItems: 'center' }}>
              <label className='me-2' style={{ width: '40px' }}>
                Del:
              </label>
              <Autocomplete
                id="country-select-demo"
                autoSelect={true}
                freeSolo={false}
                autoComplete={true}
                autoHighlight={true}
                className="dropdownContainer w-100"
                forcePopupIcon={false}
                // sx={{ width: 300 }}                
                // freeSolo={false}
                // defaultValue={pickupLocation ? pickupLocation : null }
                sx={{
                  backgroundColor: '#FFFFFF',
                  height: 'var(--input-height)',
                  minWidth: '74px',
                  borderRadius: '0.475rem',
                  width: '100%',
                  '& fieldset': {
                    border: 'none'
                  },
                  '& .MuiInputBase-root': {
                    height: 'var(--input-height)',
                    padding: '0 0 0 9px !important',
                    backgroundColor: '#ffffff'
                  }
                }}
                options={deliveryLocationOptions}
                filterOptions={(options) => options}
                value={deliveryLocation ? deliveryLocation : initialLocationValue}
                getOptionLabel={(option) => `${option?.code ? `[${option.code}] ` : ''}${option?.name}${option?.city ? '. ' : ''}${option?.city}${option.city ? ', ' : ''}${option?.state}${option?.zipcode}`}
                // filterOptions={(options, state) => {
                //   const results = defaultFilterOptions(options, state)
                //   if (results.length === 0 && state.inputValue.length > 3) {
                //     return [{ id: null, value: state.inputValue, field: 'deliveryLocation' }]
                //   }
                //   return results
                // }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  if (option?.id) {
                    return (
                      <Box
                        key={optionProps["data-option-index"]}
                        component="li"
                        sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                        {...optionProps}
                      >
                        <KTSVG path='/media/icons/bootstrap/building.svg' className='svg-icon svg-icon-5 me-2 text-danger' />
                        {`${option?.code ? `[${option.code}] ` : ''}${option?.name} ${option.name ? '.' : ''} ${option?.city} ${option.city ? ',' : ''} ${option?.state} ${option?.zipcode}`}
                      </Box>
                    )
                  }
                  // else {
                  //   return (
                  //     addNewLocation(option)
                  //   )
                  // }
                }}
                onChange={(e: object, value: any | null) => {
                  if (value) {
                    setDeliveryLocation(value)
                    formik.setFieldValue("deliveryLocation", value);
                  }
                }}
                onFocus={() => setEntityType('deliveryLocation')}

                onInputChange={(e, value) => {
                  if (e?.type === "change") {
                    if (value?.length >= 3) {
                      // if (typeof cancelToken != typeof undefined) {
                      //   cancelToken.cancel('Operation canceled due to new request.')
                      // }

                      // cancelToken = axios.CancelToken.source()
                      // console.log("input change")         
                      // setLoading(true)
                      getShippingLocations(value)
                    }
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name='deliveryLocation'
                    // label="Choose a country"
                    // error={formik.errors?.deliveryLocation?.name && formik.touched?.deliveryLocation}
                    // helperText={"fieldState.error?.message"}
                    className={classes.textField}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <InputAdornment position="end" className='d-flex align-items-center'>
                          {
                            deliveryLocation?.id ?
                              <IconButtonClearStyled
                                onClick={() => {
                                  setDeliveryLocation(initialLocationValue)
                                  formik.setFieldValue('deliveryLocation', initialLocationValue)
                                }}
                                style={{ padding: '2px !important' }}
                              >
                                <ClearIconStyled style={{ color: 'rgb(161, 165, 183) !important' }} />
                              </IconButtonClearStyled>
                              : null
                          }
                          <IconButtonStyled disabled={false}
                            onClick={() => {
                              setEntityType('deliveryLocation')
                              setOpenModalLocation(true)
                            }
                            }
                          >
                            {false ? <div className='d-flex align-items-center'><CircularProgress color="inherit" size={15} /></div> : <KTSVG path='/media/icons/bootstrap/search.svg' className='svg-icon svg-icon-6' style={{ color: '#a1a5b7' }} />}
                          </IconButtonStyled>
                        </InputAdornment>
                      ),
                      className: classes.height,
                      style: { fontSize: 14, fontFamily: 'Poppins', fontWeight: 500, paddingRight: 9, color: "#5E6278 !important" },
                      inputProps: {
                        ...params.inputProps,
                        maxLength: 120
                      }
                    }}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password',
                    }}
                  />
                )}
              />

            </div>

          </div>
        </div>

        <div className="container" style={{ padding: '0', marginBottom: '20px' }}>
          <div className="row d-flex align-items-center">
            <div className="col-12 d-flex align-items-center">
              <label className='me-2'>
                Add PO or order PDF:
              </label>
              <Button
                component="label"
                variant="contained"
                className='btn btn-primary' style={{ margin: '10px' }}
              >
                Upload File
                <input                  
                  type="file"
                  name='documents'
                  multiple
                  onChange={handleFileChange}
                  accept="image/*,
                    application/pdf,
                    application/msword,
                    application/vnd.ms-excel,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    text/plain,
                    application/zip,
                    application/x-zip-compressed,
                    multipart/x-zip,
                    application/x-rar-compressed"
                  hidden
                />
              </Button>
              <span>{fileName}</span>
            </div>
          </div>
        </div>

        <div className="container mb-5">
          <div className="row d-flex align-items-center">
            <div className="col-2">
              <label className='me-2'>48x48x48 Shingle </label>
            </div>
            <div className="col-3 d-flex align-items-center">
              <label className='me-2'>
                Skids:
              </label>
              <InputStyled
                type="text"
                className={`form-control`}
                autoComplete='off'
                name='shingle.quantity'
                value={formik.values.shingle.quantity || ''}
                onChange={formik.handleChange}
              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}                
              />
              {/* {dispatchShip && formikDispatch?.errors[formFor]?.contact ? <small className="text-danger ms-2 mt-1">Required</small> : null} */}
            </div>
            <div className="col-7 d-flex align-items-center">
              <label className='me-2' style={{ width: '150px' }}>
                Total Weight:
              </label>
              <InputStyled
                type="text"
                className={`form-control`}
                autoComplete='off'
                name='shingle.totalWeight'
                value={formik.values.shingle.totalWeight || ''}
                onChange={formik.handleChange}
              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}
              // error={dispatchShip ? formikDispatch?.errors[formFor]?.contact : ''}
              />
              {/* {dispatchShip && formikDispatch?.errors[formFor]?.contact ? <small className="text-danger ms-2 mt-1">Required</small> : null} */}
            </div>
          </div>
        </div>

        <div className="container mb-5">
          <div className="row d-flex align-items-center">
            <div className="col-2">
              <label className='me-2'>12' Siding Skid </label>
            </div>
            <div className="col-3 d-flex align-items-center">
              <label className='me-2'>
                Skids:
              </label>
              <InputStyled
                type="text"
                className={`form-control`}
                autoComplete='off'
                name='siding.quantity'
                value={formik.values.siding.quantity || ''}
                onChange={formik.handleChange}
              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}
              // error={dispatchShip ? formikDispatch?.errors[formFor]?.contact : ''}
              />
              {/* {dispatchShip && formikDispatch?.errors[formFor]?.contact ? <small className="text-danger ms-2 mt-1">Required</small> : null} */}
            </div>
            <div className="col-7 d-flex align-items-center">
              <label className='me-2' style={{ width: '150px' }}>
                Total Weight:
              </label>
              <InputStyled
                type="text"
                className={`form-control`}
                autoComplete='off'
                name='siding.totalWeight'
                value={formik.values.siding.totalWeight || ''}
                onChange={formik.handleChange}
              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}
              // error={dispatchShip ? formikDispatch?.errors[formFor]?.contact : ''}
              />
              {/* {dispatchShip && formikDispatch?.errors[formFor]?.contact ? <small className="text-danger ms-2 mt-1">Required</small> : null} */}
            </div>
          </div>
        </div>

        <div className="container mb-5">
          <div className="row d-flex align-items-center">
            <div className="col-2">
              <label className='me-2'>Loose Siding Carton </label>
            </div>
            <div className="col-3 d-flex align-items-center">
            </div>
            <div className="col-7 d-flex align-items-center">
              <label className='me-2' style={{ width: '150px' }}>
                Total Weight:
              </label>
              <InputStyled
                type="number"
                className={`form-control`}
                autoComplete='off'
                name='looseCarton.totalWeight'
                value={formik.values.looseCarton.totalWeight || ''}
                onChange={formik.handleChange}
              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}
              // error={dispatchShip ? formikDispatch?.errors[formFor]?.contact : ''}
              />
            </div>
          </div>
        </div>

        <div className="container mb-5">
          <div className="row d-flex align-items-center">
            <div className="col-6 d-flex align-items-center">
              <label className='me-2'>Other: </label>
              <InputStyled
                type="text"
                className={`form-control`}
                autoComplete='off'
                name='other.description'
                value={formik.values.other.description || ''}
                onChange={formik.handleChange}
              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}
              // error={dispatchShip ? formikDispatch?.errors[formFor]?.contact : ''}
              />
              {/* {dispatchShip && formikDispatch?.errors[formFor]?.contact ? <small className="text-danger ms-2 mt-1">Required</small> : null} */}
            </div>
            <div className="col-3 d-flex align-items-center">
              <label className='me-2'>
                Skids:
              </label>
              <InputStyled
                type="number"
                className={`form-control`}
                autoComplete='off'
                name='other.quantity'
                value={formik.values.other.quantity || ''}
                onChange={formik.handleChange}
              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}
              // error={dispatchShip ? formikDispatch?.errors[formFor]?.contact : ''}
              />
              {/* {dispatchShip && formikDispatch?.errors[formFor]?.contact ? <small className="text-danger ms-2 mt-1">Required</small> : null} */}
            </div>
            <div className="col-3 d-flex align-items-center">
              <label className='me-2' style={{ width: '160px' }}>
                Total Weight:
              </label>
              <InputStyled
                type="number"
                className={`form-control`}
                autoComplete='off'
                name='other.totalWeight'
                value={formik.values.other.totalWeight || ''}
                onChange={formik.handleChange}
              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}
              // error={dispatchShip ? formikDispatch?.errors[formFor]?.contact : ''}
              />
              {/* {dispatchShip && formikDispatch?.errors[formFor]?.contact ? <small className="text-danger ms-2 mt-1">Required</small> : null} */}
            </div>
          </div>
        </div>

        <div className="container" style={{ padding: '0 10px', marginTop: '20px', marginBottom: '20px' }}>
          <div className="row">
            <FormControl className='d-flex'>
              <RadioGroup
                sx={{ flexDirection: 'row' }}
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="serviceLevel"
                value={formik.values.serviceLevel}
                onChange={(e) => handleChangeRadios(e, 'serviceLevel')}
              >
                <FormControlLabel value="Standard LTL" control={<Radio />} label="Standard LTL" />
                <FormControlLabel value="Hot Shot/Dedicated" control={<Radio />} label="Hot Shot/Dedicated" />
                <FormControlLabel value="Economy/cheapest" control={<Radio />} label="Economy/cheapest" />
              </RadioGroup>
            </FormControl>
            {formik.errors.serviceLevel && formik.touched.serviceLevel ? <small className="text-danger ms-2 mt-1">{formik.errors.serviceLevel}</small> : null}
          </div>
        </div>

        <div className="container mb-5">
          <div className="row d-flex align-items-center">
            <div className="col-12 d-flex align-items-center">
              <label className='me-2' style={{ width: '220px' }}>
                PO or Order number(s)
              </label>
              <InputStyled
                type="text" maxlength="34"
                className={`form-control`}
                autoComplete='off'
                name='orderNumbers'
                value={formik.values.orderNumbers}
                error={formik.errors?.orderNumbers && formik.touched?.orderNumbers}
                helperText={formik.errors?.orderNumbers && formik.touched?.orderNumbers ? 'Please enter an orderNumber' : ''}
                onChange={(e) => {
                  let value = e.target.value.split(',')
                  formik.setFieldValue('orderNumbers', value)
                }
                }


              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}
              // error={dispatchShip ? formikDispatch?.errors[formFor]?.contact : ''}
              />
              {/* {dispatchShip && formikDispatch?.errors[formFor]?.contact ? <small className="text-danger ms-2 mt-1">Required</small> : null} */}
            </div>
          </div>
        </div>

        <div className="container mb-5">
          <div className="row d-flex align-items-center">
            <div className="col-12 d-flex align-items-center">
              <label className='me-2' style={{ width: '220px' }}>
                Email of shipping contact:
              </label>
              <InputStyled
                type="email"
                className={`form-control`}
                autoComplete='off'
                name='shippingContactEmail'
                value={formik.values.shippingContactEmail}
                onChange={formik.handleChange}
                error={formik.errors?.shippingContactEmail && formik.touched?.shippingContactEmail}
                helperText={formik.errors?.shippingContactEmail && formik.touched?.shippingContactEmail ? 'invalid email' : ''}

              // {...formik.getFieldProps(`${formFor}.contact`)}
              // fontSize={fontSize}
              // disabled={disabled}
              // error={dispatchShip ? formikDispatch?.errors[formFor]?.contact : ''}
              />
              {/* {dispatchShip && formikDispatch?.errors[formFor]?.contact ? <small className="text-danger ms-2 mt-1">Required</small> : null} */}
            </div>
          </div>
        </div>

        <div className="container mt-5">
          <div className="row d-flex align-items-center">
            <div className="col-12">
              <label className='me-2'>
                Notes
              </label>

              <TextField
                id="outlined-multiline-flexible"
                name='notes'
                placeholder='Type a message'
                sx={{ width: '100%', backgroundColor: '#FFFFFF', height: 'auto !important' }}
                multiline
                value={formik.values.notes}
                onChange={formik.handleChange}
                maxRows={8}
              />
            </div>
          </div>
        </div>
        <div className="container mt-5">
          <div className="row d-flex align-items-center justify-content-end" >
            <Button
              variant="contained"
              className='btn btn-primary' disabled={isSending} sx={{ width: 'auto !important' }} type="submit">Send</Button>
          </div>
        </div>

      </form>

      <ShippingLocationsModal
        open={openModalLocation}
        setOpen={setOpenModalLocation}
        setData={setLocationExternal}
        setFormikValues={formik.setFieldValue}
        formikValues={formik}
        setShippingLocationLocal={null}
        formFor='pickupLocation'
        forStops={true}
        setOpenClearRateToEditModal={null}
        setNewValuesWhenRateCleared={null}
        setOpenRemarksMessageModal={null}
      />

      <ModalStyled
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={modalclasses.modal}
        fontSize={fontSize}
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        // BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={modalclasses.paper} style={{ visibility: 'visible', opacity: '100%' }}>
            <div className="row">
              <div className="d-flex align-items-center justify-content-end">
                <div className="col-12 d-flex btn btn-icon btn-sm btn-active-light-primary" onClick={() => setOpen(false)}>
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr061.svg"
                    className="svg-icon svg-icon-2x"
                  />
                </div>
              </div>
            </div>
            <>
              <div className="row justify-content-center">
                <div className="col-12 d-flex justify-content-center">
                  <KTSVG path='/media/icons/bootstrap/check-circle.svg' className='svg-icon svg-icon-3x text-success' />
                </div>
                <div className="col-12 mt-5 d-flex justify-content-center">
                  <p style={{ fontSize: 18, fontWeight: 500, textAlign: 'center' }}>Order has been submitted</p>
                </div>
              </div>
              <div className="row mt-5 mb-3">
                <div className="col-12 d-flex justify-content-center">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setOpen(false)
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </>
          </div>
        </Fade>
      </ModalStyled>
    </>
  )
}